// filepath: apps/web/src/editors/form-builder/InlineFieldError.tsx
//
// FR-UI-BLD-1 AC-4 — inline error chip next to a field on the form
// builder canvas. Rendered as a text node (INV-9) carrying the server's
// error message verbatim.

import React from "react";
import { useTranslation } from "react-i18next";
import type { ValidationErrorWire } from "./types";

interface InlineFieldErrorProps {
  fieldId: string;
  errors: ValidationErrorWire[];
}

export function InlineFieldError({
  fieldId,
  errors,
}: InlineFieldErrorProps): React.ReactElement | null {
  const { t } = useTranslation();
  const matching = errors.filter((e) => e.node_id === fieldId);
  if (matching.length === 0) {
    return null;
  }
  return (
    <div
      className="inline-field-error"
      role="alert"
      data-testid={`inline-field-error-${fieldId}`}
    >
      {matching.map((err, idx) => (
        <span
          key={`${err.node_id}-${err.field ?? ""}-${idx}`}
          className="inline-field-error__chip"
          data-error-type={err.type}
        >
          {err.message}
          {err.field && (
            <small className="inline-field-error__field">
              {` (${err.field})`}
            </small>
          )}
        </span>
      ))}
      <span className="sr-only">{t("admin.builder.save.invalid")}</span>
    </div>
  );
}
